import { computed } from "@preact/signals-react"
import { analyzerCarPick } from "Pages/AnalyzersV2/@signals"
import { carPickBody } from "Pages/AnalyzersV2/@services/carPick"
import {
	acriss,
	analyzerDate,
	categories,
	currency,
	fuelPolicy,
	includeProviders,
	insurance,
	inTerminal,
	lengthRental,
	mainProvider,
	mainSite,
	mileage,
	offices,
	officesPickoff,
	prepaid,
	priceKpi,
	providers,
	reports,
	repricingPass,
	searchID,
	sites,
	transmission,
	webSuppliers
} from "@signals"
import { SEARCH_GROUP_BY } from "@constants"
import { tableTabSelected } from "Pages/AnalyzersV2/@signals"

export const dorPayload = computed(() => ({
	// one kind at a time: a repricing pass travels under its own key (CU-869fmm944)
	reportExecutionID: repricingPass.value ? null : reports.value,
	repricingExecutionID: repricingPass.value,
	tabKey: tableTabSelected.value,
	getDiffPriceChar: true,
	acriss: acriss.value,
	automatic: transmission.value,
	categoryID: categories.value,
	fuelPolicyID: fuelPolicy.value,
	providerID: providers.value,
	webSupplierID: webSuppliers.value,
	is_prepaid: prepaid.value,
	unlimited_km: mileage.value,
	groupBy: SEARCH_GROUP_BY.DAY,
	isDailyPrice: priceKpi.value,
	inTerminal: inTerminal.value,
	insurance: insurance.value,
	groupBySiteProvider: includeProviders.value,
	siteID: sites.value,
	currency: currency.value,
	siteMainID: mainSite.value,
	providerMainID: mainProvider.value,
	isNewVersion: true,
	searchID: searchID.value,
	officePickupID: !searchID.value ? offices.value : null,
	officeDropoffID: officesPickoff.value,
	lor: lengthRental.value,
	pickupDate: analyzerDate.value,
	reportType: 'dor',
	// the Cars selector above the table (CU-869fmpqfm): `carPickType` + `carPick`, or nothing for All cars
	...carPickBody(analyzerCarPick.value),
}))